<script>
import Base from '@backend/Base.vue';
import BOGen from '@helper/BOGen';
import draggable from 'vuedraggable'

export default {
    name: "BoSlideShow",
    extends: Base,
    components: {
        draggable,
    },
    data() {
        return {
            Name: "BoSlideShow",
            type_slide: [],
            dragData: {},
            dragging: true,
            list: [],
            dragging: false
        }
    },
    mounted() {
        this.$set(this.$root, 'page', this)
        this.refreshData()
    },
    methods:{
        endDrag(){
            BOGen.apirest('/'+Page.Name, {data:this.data.data,type:'sort'}, (err,resp)=>{
            console.log(resp)
            }, "POST");
        }
    },
    watch: {
        'data'(v){
            console.log(v)
        },
        '$route.query'(v) {
            this.refreshData()
        },
    },
};
</script>
<template>
<div class="container-fluid">
    <PageTitle></PageTitle>

    <!-- ========================================================================
    LIST DATA
    ============================================================================= -->
    <div class="panel panel-flat" v-if="!$route.params.id">
        <div class="panel-body panel-filter">
            <VForm @resp="search">
            <div class="row">
                <div class="col-sm-3">
                    <h3 class="box-title">{{ObjectName}} <span
                    v-if="data.total">({{(data.total||0).format()}})</span></h3>
                </div>
                <div class="col-sm-5"></div>
                <div class="col-sm-3">
                    <div class="has-feedback has-feedback-left">
                        <input type="search" v-model="filter.search" class="form-control" placeholder="Type and hit Enter">
                        <div class="form-control-feedback">
                            <i class="icon-search4 text-size-base text-muted"></i>
                        </div>
                    </div>
                </div>
                <div class="col-sm-1">
                    <router-link :to="{name:Name}" class="btn btn-warning">Reset</router-link>
                </div>
            </div>
            </VForm>
        </div>
        <div class="table-responsive ajax-table">
            <table class="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>
                            <SortField name="ms_type"></SortField>
                        </th>
                        <th>{{fields.ms_title}}</th>
                        <th>{{fields.ms_is_active}}</th>
                        <th width="120px">Action</th>
                    </tr>
                </thead>
                <draggable v-model="data.data" tag="tbody" @end="endDrag" style="cursor:pointer;">
                    <tr v-for="(v,k) in data.data" :key="k"> 
                        <td class="number">{{(data.per_page*(data.current_page-1))+k+1}}</td>
                        <td>{{v.ms_type == 1 ? 'Photo' :'Video'}}</td>
                        <td>{{v.ms_title}}</td>
                        <td>
                            <StatusLabel :status="v.status"></StatusLabel>
                        </td>
                        <td class="btn-action">
                            <router-link class="icon_action" :to="{name:Name,params:{id:v.id}}" v-tooltip="'Edit'">
                            <i class="icon-pencil"></i></router-link>
                            <a href="javascript:;" class="icon_action" @click="changeStatus(k)"
                            v-tooltip="'Change Status'"><i class="icon-settings"></i></a>
                            <a href="javascript:;" class="icon_action" @click="deleteItem($event,k)"
                            v-tooltip="'Remove'"><i class="icon-trash"></i></a>
                        </td>
                    </tr>
                    <tr v-if="NotFound">
                        <td colspan="99">
                            <h3 class="tc">{{NotFound}}</h3>
                        </td>
                    </tr>
                    <tr v-if="data.data===false">
                        <td colspan="99">
                            <LoadingSpinner light></LoadingSpinner>
                        </td>
                    </tr>
                </draggable>
            </table>
        </div>
        <div class="panel-body">
            <div class="pull-right">
                <Pagination :data="data" :limit="3" @pagination-change-page="onPaging"></Pagination>
            </div>
        </div>
    </div>

    <!-- ========================================================================
    FORM CRUD
    ============================================================================= -->
    <div class="panel panel-flat" v-if="$route.params.id">
        <VForm @resp="submitForm" method="post">
            <div class="panel-heading">
                <h2 class="panel-title">{{(row.id?"Edit":"Add")+" "+ObjectName}}</h2>
            </div>
            <div class="panel-body">
                <div class="info"></div>
                <div class="row">
                    <div class="col-sm-6">
                        <BoField name="ms_type">
                                <select2 name="ms_type" v-bind="validation('ms_type')" :options="type_slide" v-model="row.ms_type" class="form-control">
                                <option value="">-- Select Category --</option>
                            </select2>
                        </BoField>
                        <BoField name="ms_title" v-model="row.ms_title" v-bind="validation('ms_title')"></BoField>

                        <BoField name="ms_have_btn">
                            <div class="radio-group">
                                <radio name="ms_have_btn" v-model="row.ms_have_btn" option="Y"
                                :attr="validation('ms_have_btn')">Yes</radio>
                                <radio name="ms_have_btn" v-model="row.ms_have_btn" option="N">No</radio>
                            </div>
                        </BoField>
                        <BoField v-if="row.ms_have_btn=='Y'" name="ms_btn_label" :attr="{maxlength:100}" v-model="row.ms_btn_label" v-bind="validation('ms_btn_label')"></BoField>
                        <BoField v-if="row.ms_have_btn=='Y'" name="ms_btn_link" :attr="{type:'link',maxlength:500,placeholder:'https://farmsco.co.id/...'}" v-model="row.ms_btn_link" v-bind="validation('ms_btn_link')"></BoField>
                    </div>
                    <div class="col-sm-6">
                        <BoField name="ms_photo" v-if="row.ms_type==1" info="Ukuran: 1350x376px">
                            <Uploader name="ms_photo" type="slideshow" uploadType="galery" v-model="row.ms_photo" v-bind="validation('ms_photo')"></Uploader>
                        </BoField>
                        <BoField name="ms_file" v-if="row.ms_type==2" info="Ukuran: 1920x1080">
                            <Uploader name="ms_file" type="vid_slideshow" label="Video" uploadType="upload" v-model="row.ms_file" v-bind="validation('ms_file')"></Uploader>
                        </BoField>
                        <BoField name="ms_desc">
                            <textarea rows="4" class="form-control" name="ms_desc" v-model="row.ms_desc" v-bind="validation('ms_desc')"></textarea>
                        </BoField>
                        <BoField name="ms_is_active">
                            <div class="radio-group">
                                <radio name="ms_is_active" v-model="row.ms_is_active" option="Y"
                                :attr="validation('ms_is_active')">Active</radio>
                                <radio name="ms_is_active" v-model="row.ms_is_active" option="N">Inactive</radio>
                            </div>
                        </BoField>
                    </div>
                    <div class="col-xs-12">
                        <div class="text-right">
                            <button type="submit" class="fcbtn btn btn-info btn-outline btn-1e btn-loading">Submit form <i class="icon-arrow-right14 position-right"></i></button>
                        </div>
                    </div>
                </div>
            </div>
        </VForm>
    </div>
</div>
</template>